import { render } from "./CampaignListLayout.vue?vue&type=template&id=2bd7b4e4&scoped=true"
import script from "./CampaignListLayout.vue?vue&type=script&lang=js"
export * from "./CampaignListLayout.vue?vue&type=script&lang=js"

import "./CampaignListLayout.vue?vue&type=style&index=0&id=2bd7b4e4&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd7b4e4"]])

export default __exports__